import { Box } from "@mui/material";
import React from "react";

const NotificationDot = () => {
  return (
    <Box
      sx={{
        height: "10px",
        width: "10px",
        borderRadius: "50%",
        background: "#FF6C37",
        border: "1px solid #FF6C37",
        position: "absolute",
        top: "-15px",
        right: "-5px",
      }}
    ></Box>
  );
};

export default NotificationDot;
